import BaseNumberVTextField, { enforceFormat } from './BaseNumberVTextField'
import { formatCurrencyAmount } from '~/cynqueModules/formatDollars'

export const MAXIMUM_FRACTION_DIGITS = 2

export function enforceCurrencyFormat(event: unknown, amount: any) {
  enforceFormat(event, amount, MAXIMUM_FRACTION_DIGITS)
}

// MIGRATION (v-model, Vuetify 2 -> 3): no v-model code of its own — inherits the
// value/input -> modelValue/update:modelValue flip from BaseNumberVTextField.
export default {
  /* eslint-disable no-console */
  extends: BaseNumberVTextField,
  props: {
    blurredFormat: {
      type: Function,
      default: (v: string) => {
        const num = parseFloat(v as unknown as string)
        return Number.isFinite(num) ? formatCurrencyAmount(num) : v
      },
    },
    numericType: {
      type: String,
      default: 'currencyTextField',
    },
  },
}
